import * as Yup from "yup";
import YupPassword from "yup-password";

YupPassword(Yup);

const SignUpFormSchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      .strict()
      .lowercase("Adres email musi być w formacie email")
      .email("Adres email musi być w formacie email")
      .required("Adres email jest wymagany"),
    password: Yup.string()
      .min(8, "Hasło musi mieć co najmniej 8 znaków")
      .max(72, "Hasło może mieć maksymalnie 72 znaki")
      .minNumbers(1, "Hasło musi mieć co najmniej 1 cyfrę")
      .required("Hasło jest wymagane"),
    passwordConfirmation: Yup.string()
      .oneOf([Yup.ref("password"), null], "Hasła nie są identyczne")
      .required("Potwierdzenie hasła jest wymagane"),
    firstName: Yup.string()
      .min(3, "Imię musi mieć co najmniej 3 znaki")
      .max(20, "Imię musi mieć maksymalnie 20 znaków")
      .required("Imię jest wymagane"),
    lastName: Yup.string()
      .min(3, "Nazwisko musi mieć co najmniej 3 znaki")
      .max(20, "Nazwisko musi mieć maksymalnie 20 znaków")
      .required("Nazwisko jest wymagane"),
    idGender: Yup.number().nullable().required("Płeć jest wymagana"),
    acceptTerms: Yup.boolean().oneOf([true], "Akceptuję regulamin"),
  });
};

export default SignUpFormSchema;
